function cov_rblspg22b() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/VideoFilled.tsx";
  var hash = "85c048a761a9ce1fb120ad6fd2e587354a1a592c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/VideoFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "85c048a761a9ce1fb120ad6fd2e587354a1a592c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_rblspg22b = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_rblspg22b();
var Icon = (cov_rblspg22b().s[0]++, {
  name: 'video-filled',
  svg: "<path d=\"M2.87351 4C1.8388 4 1 4.85961 1 5.92V18.08C1 19.1404 1.8388 20 2.87351 20H14.7391C15.7738 20 16.6126 19.1404 16.6126 18.08V17.2555L20.1198 18.5854C22.5 19.4667 23 18.9333 23 16.9661V7.67391C23 5.06667 21.5 5.6 20.1198 6.05462L16.6126 7.3845V5.92C16.6126 4.85961 15.7738 4 14.7391 4H2.87351Z\" fill=\"currentColor\"/>"
});
export default Icon;